import type {
  Address,
  Review,
  Team,
  TeamClaim,
  User,
  UserTeamInterest,
} from '@baseball-near-you/prisma';
import { AbstractClient } from './AbstractFetchClient';

export class UserClient extends AbstractClient {
  getUser = this.get<
    User & {
      team: (Team & { address: Address[] }) | null;
      claims: (TeamClaim & { team: Team })[];
      Review: Pick<Review, 'id' | 'teamId'>[];
      userTeamInterest: (UserTeamInterest & {
        team: Pick<Team, 'id' | 'name' | 'logoUrl' | 'slug'> & {
          claims: Pick<TeamClaim, 'id' | 'status'>[];
        };
      })[];
      UserTeam: {
        team: Team & { address: Address[] };
        role: string;
      }[];
    },
    { args: { id: string } }
  >(({ id }) => `/${id}`);

  update = this.payloadHandler<
    User,
    {
      args: { id: string };
      payload: Partial<User>;
    }
  >('PUT', ({ id }) => `/${id}`);

  claimTeam = this.payloadHandler<
    User,
    { args: { id: string }; payload: { teamId: number } }
  >('PUT', ({ id }) => `/${id}/claim-team`);

  createUser = this.payloadHandler<User, { payload: User }>('POST', '');

  createUserTeamInterest = this.payloadHandler<
    UserTeamInterest,
    { args: { id: string }; payload: { teamId: number } }
  >('PUT', ({ id }) => `/${id}/team-interest`);
}
